<template>
  <transition name="fade">
    <div class="loading" v-if="loadingState">
      <div class="box">
        <div class="ball ball-1"></div>
        <div class="ball ball-2"></div>
        <div class="ball ball-3"></div>
        <div class="ball ball-4"></div>
        <div class="ball ball-5"></div>
        <div class="ball ball-6"></div>
      </div>
    </div>
  </transition>
</template>

<script lang="ts" setup>
import { useStore } from "vuex";
import { computed } from "vue";
import { SET_LOADING_STATE } from "@/store/modules/survey/mutations";

const store = useStore();
const loadingState = computed(() => store.state.survey.loadingState);
setTimeout(() => {
  store.commit(`survey/${SET_LOADING_STATE}`, false);
}, 6000);
</script>
<style lang="scss" scoped>
.loading {
  background: rgba(0, 0, 0, 0.9);
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  top: 0;
  left: 0;
  text-align: center;
  .box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateY(-50%) translateX(-50%);
  }
  .ball {
    width: 20px;
    height: 20px;
    background: #ccc;
    margin: auto 10px;
    animation: load1 2s infinite;
    border-radius: 100px;
    display: inline-block;
    opacity: 0;
    @media (orientation: landscape) {
      width: 20px;
      height: 20px;
      margin: auto 10px;
      border-radius: 100px;
    }
  }
  .ball-2 {
    animation-delay: 0.1s;
  }
  .ball-3 {
    animation-delay: 0.2s;
  }
  .ball-4 {
    animation-delay: 0.3s;
  }
  .ball-5 {
    animation-delay: 0.4s;
  }
  .ball-6 {
    animation-delay: 0.5s;
  }
}
</style>
